<template>
  <v-row no-gutters>
    <v-col cols="12" md="12" class="mt-2 pl-2 pr-2">
      <v-row
        no-gutters
        class="pl-2 pt-2 pr-2"
        :style="{
          backgroundColor: '#FFCDD2',
        }"
      >
        <v-col cols="3" md="3">
          <span>
            <img :src="srcMethod(tempPage.photo)" height="50vh" width="50vh"
          /></span>
        </v-col>
        <v-col cols="7" md="7" class="mt-2">
          <span
            ><h4>{{ tempPage.title }}</h4></span
          >
        </v-col>
        <v-col cols="2" md="2" class="text-right">
          <v-icon @click="$emit('closeDialog')">mdi-close-box-outline</v-icon>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" md="12" class="pl-2 pr-2">
      <v-row no-gutters>
        <v-col
          cols="12"
          md="12"
          class="mt-1 pl-2 pr-2"
          v-for="(item, index) in customerList"
          :key="index"
          :style="{
            backgroundColor:
              item.pageUserId == selectedOne.pageUserId
                ? '#def3ff'
                : 'transparent',
          }"
          @click="selectedOne = item"
        >
          <v-card variant="outlined">
            <v-row no-gutters class="pa-1" @click="clickCustomer(item)">
              <v-col cols="2" md="2">
                <span>
                  <div
                    class="container"
                    width="30vh"
                    height="30vh"
                    v-if="item.participantDto.active"
                  >
                    <v-avatar
                      variant="outlined"
                      :image="
                        srcMethodProfile(item.participantDto.profilePhoto)
                      "
                      size="50"
                    >
                    </v-avatar>
                    <div class="bottom-right">
                      <span class="dot"></span>
                    </div>
                  </div>
                  <v-avatar
                    v-else
                    variant="outlined"
                    :image="srcMethodProfile(item.participantDto.profilePhoto)"
                    size="50"
                  ></v-avatar>
                </span>
              </v-col>
              <v-col cols="9" md="9" class="pl-3">
                <v-row no-gutters>
                  <v-col cols="9" md="8">
                    <span
                      ><h4>{{ item.participantDto.profileName }}</h4></span
                    >
                  </v-col>
                  <v-col cols="3" md="4">
                    <span class="text-right"
                      ><h6>{{ item.messageDate }}</h6></span
                    >
                  </v-col>
                  <v-col cols="10" md="10">
                    <div
                      class="cut-text text-caption"
                      v-if="item.sendMessage != ''"
                    >
                      {{ item.sendMessage }}
                    </div>
                    <div class="text-caption" v-else>Photo message</div>
                  </v-col>
                  <v-col cols="2" md="2" v-if="item.look != 0">
                    <center>
                      <v-btn variant="tonal" size="x-small" flat icon
                        ><h4>{{ item.look }}</h4></v-btn
                      >
                    </center>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import pgService from "../service/PageService";
import axios from "../config";
export default {
  data: () => ({
    selectedOne: {},
    customerList: [],
    loginUser:{},
  }),
  props: { tempPage: Object },
  mounted: function () {
    this.loginUser = this.$store.state.userAccountChat;
    this.pageUserListMethod();
    this.disconnect();
    this.connection();
  },
  methods: {
    disconnect() {
      if (this.stompClient) {
        this.stompClient.disconnect();
      }
      this.connected = false;
    },
    connection() {
      this.connected ? this.disconnect() : this.connect();
    },
    connect() {
      let socket = new SockJS("/chat");
      this.stompClient = Stomp.over(socket);
      this.stompClient.connect(
        {},
        (frame) => {
          this.connected = true;
          this.stompClient.subscribe("/mbt/friends/active", (response) => {
            let userObj = JSON.parse(response.body);
            if (userObj.webSocket == "UA") {
              //user active
              for (let i = 0; i < this.customerList.length; i++) {
                let obj = this.customerList[i];
                if (userObj.userAccountId == obj.participantDto.userAccountId) {
                  obj.participantDto.active = userObj.active;
                }
              }
            } else if (userObj.webSocket == "M") {
              if (this.tempPage.pageId == userObj.pageDto.pageId) {
                if (userObj.userAccountDto != null) {
                    for (let i = 0; i < this.customerList.length; i++) {
                    let obj = this.customerList[i];
                    if (
                      userObj.userAccountDto.userAccountId!=this.loginUser.userId
                                                &&
                                                obj.participantDto.userAccountId==userObj.userAccountDto.userAccountId
                    ) {
                      obj.sendMessage = userObj.sendMessage;
                      obj.messageDate = userObj.time;
                      obj.look = Number(obj.look) + 1;
                    }
                  }
                } else {
                  for (let i = 0; i < this.customerList.length; i++) {
                    let obj = this.customerList[i];
                    if (
                      obj.participantDto.userAccountId == userObj.customerId
                    ) {
                      obj.look = Number(0);
                    }
                  }
                }
              }
            }
          });
        },
        (error) => {
          this.connected = false;
        }
      );
    },
    clickCustomer: function (item) {
      this.$emit("customerMethod", item);
    },
    pageUserListMethod: function () {
      pgService
        .getPageUser(this.tempPage.pageId, "C")
        .then((response) => {
          this.customerList.splice(0, this.customerList.length);
          this.customerList.push(...response);
        })
        .catch((error) => {
          this.$swal("Fail!", error.response.data.message, "error");
        });
    },
    srcMethod: function (pictureCode) {
      return `${axios.defaults.baseURL}/pagephoto/${pictureCode}.png`;
    },
    srcMethodProfile: function (pictureCode) {
      if (pictureCode == undefined) {
        return `/info/logo.png`;
      } else {
        return `${axios.defaults.baseURL}/userphoto/${pictureCode}.png`;
      }
    },
  },
  watch: {},
  components: {},
};
</script>
<style scoped>
.container {
  position: relative;
  height: 8vh;
  width: 8vh;
}

.bottom-right {
  position: absolute;
  bottom: 2px;
  right: 6px;
}

.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.dot {
  height: 10px;
  width: 10px;
  background-color: #00ff62;
  border-radius: 50%;
  display: inline-block;
}
</style>